import { createAction } from "redux-act";
export const setDownloadCheckpoint = createAction("SET_DOWNLOAD_CHECKPOINT", (id, checkpoint) => ({ id, checkpoint }));
export const clearDownloadCheckpoint = createAction("CLEAR_DOWNLOAD_CHECKPOINT", (id) => ({ id }));
